import React, { useEffect, useState } from 'react'
import './index.scss'
import { ReactComponent as MomoIcon } from './../../assets/icons/Momo.svg'
import { ReactComponent as BankIcon } from './../../assets/icons/bank.svg'
import gtelPay from './../../assets/img/gtelPay.png'
import PaymentService from '../../services/paymentService'
import { useAppParamsContext } from '../../context/AppParamsContext'

export const PAYMENT_TYPE_CODE = {
  ATM_BANK: 'ATM_BANK',
  MOMO: 'MOMO',
  GTELPAY: 'GTELPAY',
  VNPAY: 'VNPAY',
  VNPAY_INAPP: 'VNPAY_INAPP',
  ZALOPAY: 'ZALOPAY',
  VIETTEL_PAY: 'VIETTEL_PAY',
  TA_MOVE: 'TA_MOVE',
  SEPAY: 'SEPAY',
  SHOPEEPAY: 'SHOPEEPAY',
  BAOKIM: 'BAOKIM',
  KIMNGAN: 'KIMNGAN'
}

export const PAYMENT_TYPE = {
  ATM_BANK: 1,
  MOMO_BANK: 2,
  GTEL_PAY: 3,
  VNPAY: 4,
  ZALOPAY: 5,
  VIETTEL_PAY: 6,
  TA_MOVE: 7,
  SEPAY: 8,
  VIETTEL_MONEY: 9,
  SHOPEEPAY: 10,
  BAOKIM: 11,
  KIMNGAN: 12
}

// Mapping theo những cái truyền lên params đã gửi khách hàng
export const PAYMENT_TYPE_PARAMS = {
  ATM_BANK: ['bank'],
  MOMO_BANK: ['momo'],
  GTEL_PAY: ['gtelpay'],
  VNPAY: ['vnpay'],
  ZALOPAY: ['zalopay'],
  VIETTEL_PAY: ['viettelpay', 'viettel_pay'],
  TA_MOVE: ['tamove'],
  SEPAY: ['sepay'],
  VIETTEL_MONEY: ['viettelmoney', 'viettel_money'],
  SHOPEEPAY: ['shopeepay', 'shopee_pay'],
  BAOKIM: ['baokim'],
  KIMNGAN: ['kimngan', 'kim_ngan']
}

// Kiểm tra nếu là TaMove thì sẽ ẩn ngân hàng, nếu là Ngân hàng thì sẽ ẩn tamove
export const PAYMENT_METHOD_ID_SHOW_HIDE_WITH_THEME = {
  bank: {
    value: 'bank',
    paymentTypeCode: PAYMENT_TYPE_CODE.ATM_BANK,
    theme: ['TTDK', 'DKON', 'VIPMEMBER', 'IHANOI']
  },
  TAMove: {
    value: 'TAMove',
    paymentTypeCode: PAYMENT_TYPE_CODE.TA_MOVE,
    theme: ['TAMOVE']
  },
  gtelPay: {
    value: 'gtelPay',
    paymentTypeCode: PAYMENT_TYPE_CODE.GTELPAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER']
  },
  zaloPay: {
    value: 'zaloPay',
    paymentTypeCode: PAYMENT_TYPE_CODE.ZALOPAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER']
  },
  vnpay: {
    value: 'vnpay',
    paymentTypeCode: PAYMENT_TYPE_CODE.VNPAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER', 'TAMOVE']
  },
  shopeePay: {
    value: 'shopeePay',
    paymentTypeCode: PAYMENT_TYPE_CODE.SHOPEEPAY,
    theme: ['TTDK', 'DKON', 'VIPMEMBER']
  },
  baoKim: {
    value: 'baoKim',
    paymentTypeCode: PAYMENT_TYPE_CODE.BAOKIM,
    theme: ['TAMOVE']
  },
  kimNgan: {
    value: 'kimngan',
    paymentTypeCode: PAYMENT_TYPE_CODE.KIMNGAN,
    theme: ['TAMOVE']
  },
  vnpayInApp: {
    value: 'vnpayInApp',
    paymentTypeCode: PAYMENT_TYPE_CODE.VNPAY_INAPP,
    theme: []
  }
}

const getVisibleMethodsByTheme = (paymentMethods = [], themeName) => {
  return paymentMethods.filter((method) => {
    // Tìm trong config
    const config = Object.values(PAYMENT_METHOD_ID_SHOW_HIDE_WITH_THEME).find((item) => item.paymentTypeCode === method.paymentTypeCode)

    // Nếu không có config -> mặc định hiển thị
    if (!config) return true
    // Nếu có config, chỉ hiển thị khi theme đúng
    return config.theme.includes(themeName)
  })
}

// Cho Web TAMOVE: TASCO > Thanh toán qua TAMOVE, còn lại qua TTDK
const resolveThemeForFilter = ({ currentTheme, paymentChannel, selectedProductBrand }) => {
  if (paymentChannel) return paymentChannel
  if (currentTheme !== 'TAMOVE') return undefined
  return selectedProductBrand === 'TASCO' ? 'TAMOVE' : 'TTDK'
}

export const checkShowPaymentMethodWithTheme = (paymentMethods = []) => {
  const currentTheme = process.env.REACT_APP_THEME_NAME || 'TTDK'
  return getVisibleMethodsByTheme(paymentMethods, currentTheme)
}

const getTascoPaymentMethods = (paymentMethods = []) => {
  return paymentMethods.filter(
    (item) =>
      Number(item?.paymentMethodType) === PAYMENT_TYPE.TA_MOVE ||
      item?.paymentTypeCode === PAYMENT_TYPE_CODE.TA_MOVE
  )
}

const PaymentMethodSelection = ({ paymentMethod, setPaymentMethod, setListPaymentMethod = () => {}, paymentChannel, selectedProductBrand }) => {
  const [data, setData] = useState({})
  const { paymentMethodType } = useAppParamsContext()
  const currentTheme = process.env.REACT_APP_THEME_NAME || 'TTDK'
  const effectiveTheme = resolveThemeForFilter({ currentTheme, paymentChannel, selectedProductBrand })
  const isTascoInsurance = (selectedProductBrand || '').toUpperCase() === 'TASCO'

  useEffect(() => {
    ;(async () => {
      try {
        const responseData = await PaymentService.getPaymentQRMethod({})

        let filteredData = Object.values(responseData || {})

        // Tasco chỉ cho phép TAMove từ danh sách BE trả về.
        if (isTascoInsurance) {
          filteredData = getTascoPaymentMethods(filteredData)
        } else if (effectiveTheme) {
          filteredData = getVisibleMethodsByTheme(filteredData, effectiveTheme)
          // Có phương thức thanh toán chỉ định từ tham số thì dùng nó
        } else if (paymentMethodType !== undefined && paymentMethodType !== null) {
          filteredData = filteredData.filter((item) => item.paymentMethodType === paymentMethodType)
          // Danh sách phương thức thanh toán của theme hiện tại
        } else {
          filteredData = getVisibleMethodsByTheme(filteredData, currentTheme)
        }

        const dataConverted = Object.fromEntries(filteredData.map((item) => [item.paymentMethodId, item]))
        setPaymentMethod(Object.values(dataConverted || {})?.[0]?.paymentMethodId)
        setData(dataConverted)
        setListPaymentMethod(dataConverted)
      } catch (err) {
        console.log('fail to get payment methods')
      }
    })()
  }, [paymentMethodType, effectiveTheme, currentTheme, isTascoInsurance, setListPaymentMethod, setPaymentMethod])

  return (
    <div className="payment-method-selection">
      <h6 className="mb-0">Phương thức thanh toán</h6>
      <div className="text-primary">Vui lòng chọn 1 hình thức</div>

      <div className="mt-3">
        <div className="d-flex flex-row gap-3 align-items-center flex-wrap">
          {Object.values(data).length > 0 &&
            Object.values(data)?.map(
              (item) =>
                item?.paymentMethodEnable === 1 && (
                  <div
                    key={item?.paymentMethodId}
                    onClick={() => setPaymentMethod(item?.paymentMethodId)}
                    className={`payment-method-selection-item py-3 d-flex flex-column align-items-center justify-content-between gap-2 bg-white ${
                      Object.values(data)?.length === 1 && 'w-100'
                    } ${paymentMethod === item?.paymentMethodId && 'active'}`}>
                    <img
                      height={(item?.paymentMethodName === 'ZaloPay' || !item?.paymentMethodImageUrl) ? 45 : 30}
                      src={item?.paymentMethodImageUrl || item?.paymentTypeImageUrl}
                      alt={item?.paymentMethodReferName}
                    />
                    <div className='text-center'>{item?.paymentMethodName || item?.paymentTypeName}</div>
                  </div>
                )
            )}
        </div>
      </div>
    </div>
  )
}

export default PaymentMethodSelection
